import _objectSpread from "E:/workspace/ysorder/order_admin_client/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.string.includes.js";
import draggable from "vuedraggable";
import emptySort from "@/resource/images/empty-sort.png";
import { mapState } from "vuex";
import CardItem from '../components/CardItem';

// import {throttle} from '@/utils/util'
import { throttle, debounce } from "throttle-debounce";
import FormPage from '@/pages/designCategory/components/FormPage';
import SimpleFormPage from '@/pages/designCategory/components/SimpleFormPage';
// import Postmate from "@/lib/postmate";
// Postmate.debug = false
export default {
  i18n: require('../../design/design_i18n'),
  components: {
    FormPage: FormPage,
    draggable: draggable,
    CardItem: CardItem,
    SimpleFormPage: SimpleFormPage
  },
  data: function data() {
    return {
      loading: false,
      closeTip: null,
      // 拖拽组件参数
      dragOptions: {
        animation: 200,
        // 动画时间
        group: "description",
        disabled: false,
        ghostClass: "sortable-ghost",
        dragClass: "sortable-drag",
        filter: ".ignore-elements"
      },
      inDrag: false,
      // 是否正在拖拽
      inHover: 0,
      // 鼠标 hover 的 <li> 的 component_id
      images: {
        emptySort: emptySort
      },
      isExpand: true,
      // 展开收起 true=展开 false=收起
      // component: null, // 选中的组件

      form: this.$form.createForm(this),
      showTypes: [{
        value: 'mutil',
        label: '多级菜单'
      }, {
        value: 'simple',
        label: '一级菜单'
      }]
    };
  },
  // created(){
  //   this.component = this.$store.state.design.selected_vdc;
  // },
  // watch: {
  //   selected_vdc_id () {
  //           this.component = this.$store.state.design.selected_vdc;
  //       }
  // },

  computed: _objectSpread(_objectSpread({}, mapState({
    component: function component(state) {
      return state.designCategory.select_com;
    },
    show: function show(state) {
      return state.designCategory.show_component_form;
    },
    pageData: function pageData(state) {
      return state.designCategory.pageData;
    },
    langId: function langId(state) {
      return state.designCategory.langId;
    },
    simpleComponent: function simpleComponent(state) {
      return state.designCategory.select_simple_com;
    },
    showOp: function showOp(state) {
      return state.designCategory.showOp;
    }
  })), {}, {
    componentType: function componentType() {
      return function (item) {
        // 中间部分的组件没有draggable属性
        if (typeof item.draggable === 'undefined') {
          var location = item.componentValue.location;

          // 包含了 1,2 return PC | 移动
          // 包含了 1 return PC
          // 包含了 2 return 移动
          if (location.includes(1) && location.includes(2)) {
            return 'PC | 移动';
          }
          if (location.includes(1)) {
            return 'PC';
          }
          if (location.includes(2)) {
            return '移动';
          }
          return '';
        } else {
          // 说明是固定位置的组件
          return item.type;
        }
      };
    }
  }),
  mounted: function mounted() {
    // let han = new Postmate({
    //
    // })
    // han.then(p => {
    //   console.log('right 调用say()')
    //   p.say()
    // })
  },
  methods: {
    handleTypeChange: function handleTypeChange(val) {
      if (val === 'mutil') {
        this.$store.commit('designCategory/setSelectSimpleCom', '');
        this.$store.commit('designCategory/setShowSimpleForm', false);
      } else if (val === 'simple') {
        // this.$store.commit('designCategory/setSelectedCom', '')
        // this.$store.commit('designCategory/setSelectedId', '')
        this.$store.commit('designCategory/setSelectRightCom', '');
      }
      this.$store.commit('designCategory/setShowOp', false);
      this.$store.commit('designCategory/setShowSimpleOp', false);
    },
    handleExpand: function handleExpand() {
      this.isExpand = !this.isExpand;
      // if(this.isExpand) {
      //   this.$store.commit('design/setShowForm')
      // }else {
      //   this.$store.commit('design/setHideForm')
      // }
    }
  }
};